export default __webpack_public_path__ + "static/discover-parks-instagram-dark-green-icon-with-text-48d2bc412e7bf0977b03dd09dce040f5.png";